export default {"src":"/_next/static/media/hospital 1.690308b7.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};